import {
    Box,
    Container,
    Typography,
    Paper,
    useTheme,
    Divider,
    List,
    ListItem,
    ListItemText
} from '@mui/material';

const Privacy = () => {
    const theme = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    Privacy Policy
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" paragraph>
                    Last Updated: January 1, 2025
                </Typography>

                <Typography paragraph sx={{ mt: 4 }}>
                    Total Turf Experience ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    1. Information We Collect
                </Typography>
                <Typography paragraph>
                    We collect the following types of information:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText 
                            primary="Personal Information"
                            secondary="Name, date of birth, email address, phone number, and postal address"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Account Information"
                            secondary="Login credentials, membership status, and payment information"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Usage Data"
                            secondary="Facility check-in/out times, service usage, and website interaction"
                        />
                    </ListItem>
                </List>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    2. How We Use Your Information
                </Typography>
                <Typography paragraph>
                    We use your information for:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText 
                            primary="Facility Access"
                            secondary="Managing entry passes and facility access"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Account Management"
                            secondary="Processing payments and maintaining membership records"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Communication"
                            secondary="Sending important updates about your membership and facility information"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Service Improvement"
                            secondary="Analyzing usage patterns to enhance our services"
                        />
                    </ListItem>
                </List>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    3. Information Sharing
                </Typography>
                <Typography paragraph>
                    We do not sell your personal information. We may share your information with:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText 
                            primary="Service Providers"
                            secondary="Third-party services that help us operate (e.g., payment processors, facility management software)"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Legal Requirements"
                            secondary="When required by law or to protect our rights"
                        />
                    </ListItem>
                </List>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    4. Data Security
                </Typography>
                <Typography paragraph>
                    We implement appropriate security measures to protect your information from unauthorized access, alteration, or disclosure. However, no internet transmission is completely secure.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    5. Children's Privacy
                </Typography>
                <Typography paragraph>
                    We collect information about children only with parental consent and in compliance with applicable laws. Parents can review, update, or request deletion of their child's information.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    6. Your Rights
                </Typography>
                <Typography paragraph>
                    You have the right to:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText 
                            primary="Access"
                            secondary="Review your personal information"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Correction"
                            secondary="Update inaccurate information"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary="Deletion"
                            secondary="Request removal of your information"
                        />
                    </ListItem>
                </List>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    7. Cookies and Tracking
                </Typography>
                <Typography paragraph>
                    We use cookies and similar technologies to improve your experience and analyze website usage. You can control cookie settings through your browser preferences.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    8. Changes to Privacy Policy
                </Typography>
                <Typography paragraph>
                    We may update this Privacy Policy periodically. We will notify you of significant changes through our website or email.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    9. Contact Us
                </Typography>
                <Typography paragraph>
                    For privacy-related questions or concerns, please contact:
                </Typography>
                <Typography>
                    Total Turf Experience<br />
                    614 Lambs Road<br />
                    Pitman, NJ 08071<br />
                    Phone: (856) 218-8091<br />
                    Email: info@totalturf.net
                </Typography>
            </Paper>
        </Container>
    );
};

export default Privacy; 